/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Michael Kokoulin
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.0.1
 */

export interface ILocaleEnum {
    ru: string;
    en: string;
}

export const LocaleEnum: ILocaleEnum = {
    ru: 'ru',
    en: 'en',
};

export enum ELocaleKeys {
    date = 'date',
    format = 'format',
    minutes = 'minutes',
    name = 'name',
    number = 'number',
    seconds = 'seconds',
    status = 'status',
    string = 'string',
}
